module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/component/demo/demo/demo.component.less
// module id = ./src/app/component/demo/demo/demo.component.less
// module chunks = common